import styles from "./index.module.scss";
import Stack from "@mui/material/Stack";
import { IContentWithAnimation } from "../../shared/types";
import sp_fc_map from "../../assets/images/schools-page/sp_fc_map.png";
import sc_tablet_map from "../../assets/images/schools-page/sc_tablet_map.png";
import sc_mobile_map from "../../assets/images/schools-page/sc_mobile_map.png";
import sc_fc_rightBottom_Bg from "../../assets/images/schools-page/sc_fc_rightBottom_Bg.png";
import sp_fc_leftBottom_bg from "../../assets/images/schools-page/sp_fc_leftBottom_bg.png";
import sp_fc_leftTop_bg from "../../assets/images/schools-page/sp_fc_leftTop_bg.png";
import sp_sc_bg_pink from "../../assets/images/schools-page/sp_sc_bg_pink.png";
import sp_sc_bg_yellow from "../../assets/images/schools-page/sp_sc_bg_yellow.png";
import sc_tc_blue_bg from "../../assets/images/schools-page/sc_tc_blue_bg.png";
import sc_tc_pink_bg from "../../assets/images/schools-page/sc_tc_pink_bg.png";
import sc_tc_device from "../../assets/images/schools-page/sc_tc_device.png";
import sp_forthC_blue_bg from "../../assets/images/schools-page/sp_forthC_blue_bg.png";
import sp_forthC_device from "../../assets/images/schools-page/sp_forthC_device.png";
import sp_forthC_yellow_bg from "../../assets/images/schools-page/sp_forthC_yellow_bg.png";
import sp_sev_img from "../../assets/images/schools-page/sp_sev_img.png";
import school_charge_chart from "../../assets/images/schools-page/school_charge_chart.png";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import globalStyles from "../../shared/_stylesParams.module.scss";
import StyledAccordion from "../../components/StyledAccordion";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import { TabNames } from "../../routers/type";
import { TeacherPageFifthContent } from "../TeacherPage/components";
import { convert1DArrayTo2DArray } from "../../helpers/convert1DArrayTo2DArray";
import tp_fif_banner_blue from "../../assets/images/teachers-page/tp_fif_banner_blue.png";
import tp_fif_banner_pink from "../../assets/images/teachers-page/tp_fif_banner_pink.png";
import tp_fif_banner_yellow from "../../assets/images/teachers-page/tp_fif_banner_yellow.png";
import tp_fif_banner_grey from "../../assets/images/teachers-page/tp_fif_banner_grey.png";
import tp_fif_banner_green from "../../assets/images/teachers-page/tp_fif_banner_green.png";
import confirmBooking from "../../assets/images/schools-page/schoolConfirmBooking.png";
import schoolInvoices from "../../assets/images/schools-page/sc_invoices.png";
import teacherProfile from "../../assets/images/schools-page/schoolViewTeacherProfile.png";
import bookableTeachers from "../../assets/images/schools-page/schoolBookableTeachers.png";
import requestTeachers from "../../assets/images/schools-page/schoolRequestTeachers.png";
import bookable from "../../assets/images/schools-page/BookableTab.png";

import nswBand1 from "../../assets/images/schools-page/nsw_band1.png";
import nswBand2 from "../../assets/images/schools-page/nsw_band2.png";
import nswBand3 from "../../assets/images/schools-page/nsw_band3.png";

import {
  fadeIn,
  transitionCubicBezier,
  slideBasedOnMarginRight,
  slideBasedOnMarginLeft,
  scaleUP,
  slideBasedOnMarginTop,
} from "../../shared/animations";
import { setRegisterAs } from "../../redux/uiSlice";
import { Divider, Fade } from "@mui/material";
import pxToRem from "../../helpers/pxToRem";
import { useEffect, useMemo, useRef, useState } from "react";
import { BAND1_COST, BAND2_COST, BAND3_COST } from "./constants";
import { SchoolPageInfoDisplayBoxNSW } from "./locationBasedPages/nswComponents";
import { NewSchoolPageInfoDisplayBox } from "./locationBasedPages/vicComponents";

export const SchoolPageFirstContent = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Stack
      className={`${styles.fc_container} flex_row_center`}
      width={"100%"}
      direction='row'
      alignItems={screenType === "MOBILE" ? "flex-start" : "center"}
      justifyContent={"center"}
    >
      <img
        src={
          screenType === "PC"
            ? sp_fc_map
            : screenType === "TABLET"
              ? sc_tablet_map
              : sc_mobile_map
        }
        alt={`Find and book nearby relief teachers in the Spark app`}
        className={styles.fc_map}
        style={{ ...fadeIn(loadedAnimation), ...transitionCubicBezier }}
      />
      <Stack
        direction='column'
        alignItems={screenType === "MOBILE" ? "center" : "flex-end"}
        className={styles.sc_fc_rightContainer}
      >
        <Box
          className={`${styles.fc_title} ${screenType === "PC"
            ? ""
            : screenType === "TABLET"
              ? "display_small"
              : "title_large"
            }`}
          sx={{
            ...fadeIn(loadedAnimation),
            ...scaleUP(loadedAnimation),
            ...transitionCubicBezier,
          }}
        >
          Find & Book {screenType === "TABLET" ? <br /> : ""} Nearby <br />{" "}
          Relief Teachers
        </Box>
        <div className={styles.fc_divider} />
        <Button
          className={`${styles.sp_fc_button} ${screenType === "PC"
            ? "headLine_small semi_bold_weight"
            : `${screenType === "TABLET" ? "title_medium" : "label_large "
            }  medium_weight`
            }`}
          onClick={() => {
            dispatch(setRegisterAs('School'));
            navigate(`/${TabNames.REGISTER}`)
          }
          }
          sx={{
            ...fadeIn(loadedAnimation),
            ...scaleUP(loadedAnimation),
            ...transitionCubicBezier,
            transitionDelay: "0.3s",
          }}
        >
          Register Now
        </Button>
        <Box
          className={styles.sc_fc_right_bgCombination_warpper}
          sx={{ ...slideBasedOnMarginRight(loadedAnimation, "0px", "-100px") }}
        >
          <img
            src={sp_fc_leftBottom_bg}
            alt='sc_fc_rightTop_bg'
            className={styles.sc_fc_rightTop_bg}
          />
          <img
            src={sc_fc_rightBottom_Bg}
            alt='sc_fc_rightBottom_Bg'
            className={styles.sc_fc_rightBottom_Bg}
          />
        </Box>
        <Box
          className={styles.sc_fc_left_bgCombination_warpper}
          sx={{ ...slideBasedOnMarginLeft(loadedAnimation, "0px", "-100px") }}
        >
          <img
            src={sp_fc_leftBottom_bg}
            alt='sp_fc_leftBottom_bg'
            className={styles.sp_fc_leftBottom_bg}
          />
          <img
            src={sp_fc_leftTop_bg}
            alt='sp_fc_leftTop_bg'
            className={styles.sp_fc_leftTop_bg}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

interface ISchoolPageInfoDisplayBoxDesBox {
  title: string;
  des: string;
  underScoreColor: string;
  desBoxBgColor: string;
}

export const SchoolPageInfoDisplayBoxDesBox = ({
  title,
  des,
  underScoreColor,
  desBoxBgColor,
}: ISchoolPageInfoDisplayBoxDesBox) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <Stack
      alignItems={"center"}
      className={styles.SchoolPageInfoDisplayBoxDesBox}
    >
      <Stack justifyContent='center' alignItems='center'>
        <Box
          className={`${styles.SchoolPageSecondContentDesBox_title} ${screenType === "PC"
            ? "headLine_large semi_bold_weight"
            : "title_medium bold_weight"
            }`}
        >
          {title}
        </Box>
        <div
          className={styles.SchoolPageSecondContentDesBox_divider}
          style={{ background: underScoreColor }}
        ></div>
      </Stack>
      <Stack
        className={styles.SchoolPageSecondContentDesBox_desContainer}
        justifyContent='center'
        sx={{ background: desBoxBgColor }}
        alignItems='center'
      >
        <Box
          className={`${styles.SchoolPageSecondContentDesBox_des} ${screenType === "PC" ? "title_medium" : "label_large"
            } medium_weight`}
        >
          {des}
        </Box>
      </Stack>
    </Stack>
  );
};

export interface ISchoolPageInfoDisplayBox extends IContentWithAnimation {
  loadedAnimation: boolean;
  title: string;
  description: string | JSX.Element;
  leftTopBgImg: string;
  leftTopBgImgAlt: string;
  leftBottomBgImg: string;
  leftBottomBgImgAlt: string;
  deviceImg: string;
  deviceImgAlt: string;
  rowDirectionReversed?: boolean;
  contents: {
    title: string;
    des: string;
  }[];
  underScoreColor: string;
  desBoxBgColor: string;
}

export const SchoolPageInfoDisplayBox = ({
  loadedAnimation,
  title,
  description,
  leftTopBgImg,
  leftTopBgImgAlt,
  leftBottomBgImg,
  leftBottomBgImgAlt,
  deviceImg,
  deviceImgAlt,
  contents,
  rowDirectionReversed,
  underScoreColor,
  desBoxBgColor,
}: ISchoolPageInfoDisplayBox) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);
  const slideInAnimation = rowDirectionReversed
    ? slideBasedOnMarginLeft(loadedAnimation, "0px", "-200px")
    : slideBasedOnMarginRight(loadedAnimation, "0px", "-200px");

  return (
    <Stack className={`flex_row_center`}>
      <Stack className={`${styles.sc_container}`}>
        <Box
          className={`${styles.sc_title} heading1`}
          sx={{
            ...fadeIn(loadedAnimation),
            ...scaleUP(loadedAnimation),
            ...transitionCubicBezier,
          }}
        >
          {title}
        </Box>
        <Box
          className={`${styles.sc_para} paragraph2`}
          sx={{
            ...fadeIn(loadedAnimation),
            ...scaleUP(loadedAnimation),
            ...transitionCubicBezier,
          }}
        >
          {description}
        </Box>
        <Stack
          className={styles.sc_bottomStack}
          direction={
            screenType === "MOBILE"
              ? "column"
              : rowDirectionReversed
              ? "row-reverse"
              : "row"
          }
          alignItems='center'
          justifyContent='space-between'
        >
          <Box className={styles.sc_imgWrapper}>
            <img
              src={leftBottomBgImg}
              alt={leftBottomBgImgAlt}
              className={styles.sp_sc_bg_pink}
            />
            <img
              src={leftTopBgImg}
              alt={leftTopBgImgAlt}
              className={styles.sp_sc_bg_yellow}
            />
            <img
              src={deviceImg}
              alt={deviceImgAlt}
              className={styles.sp_sc_device}
            />
          </Box>
          <Stack
            className={styles.SchoolPageInfoDisplayBox_contentStack}
            direction={"column"}
          >
            {screenType === "MOBILE"
              ? convert1DArrayTo2DArray(contents, 2).map((contentArr) => (
                  <Stack
                    className={styles.SchoolPageInfoDisplayBox_contentRow}
                    direction={"row"}
                  >
                    {contentArr.map((config) => (
                      <SchoolPageInfoDisplayBoxDesBox
                        key={config.title}
                        {...config}
                        underScoreColor={underScoreColor}
                        desBoxBgColor={desBoxBgColor}
                      />
                    ))}
                  </Stack>
                ))
              : contents.map((config, index) => (
                  <div
                    key={config.title}
                    style={{
                      ...slideInAnimation,
                      ...slideBasedOnMarginLeft(
                        loadedAnimation,
                        "0px",
                        "-200px"
                      ),
                      transitionDelay: `${(index - 1) * 0.3}s`,
                    }}
                  >
                    <SchoolPageInfoDisplayBoxDesBox
                      {...config}
                      underScoreColor={underScoreColor}
                      desBoxBgColor={desBoxBgColor}
                    />
                  </div>
                ))}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

const SCHOOL_PAGE_SECOND_CONTENT_DES_CONFIGS = [
  {
    title: "Request Teachers",
    des: "Send out requests for any upcoming working day this term or next and nearby teachers will be asked if they are available.",
  },
  {
    title: "Confirm Teachers",
    des: "Teachers who confirm their availability will appear on your screen and you can confirm who you would like to work at your school.",
  },
  {
    title: "One Invoice",
    des: "Once a week your school will receive an invoice for the bookings completed the week before. We look after the teachers' payroll info so you don't have to.",
  },
];

export const SchoolPageSecondContent = ({
  loadedAnimation,
}: IContentWithAnimation) => (
  <NewSchoolPageInfoDisplayBox
    loadedAnimation={loadedAnimation}
    title={"What is Spark?"}
    description={`Spark Relief Teachers employs casual relief teachers throughout Victoria. Our platform is simple to use and is designed so that schools can easily send out requests and source casual relief teachers when required.`}
    leftTopBgImg={sp_sc_bg_yellow}
    leftTopBgImgAlt={"sp_sc_bg_yellow"}
    leftBottomBgImg={sp_sc_bg_pink}
    leftBottomBgImgAlt={"sp_sc_bg_pink"}
    deviceImg={bookable}
    deviceImgAlt={"Spark Relief Teachers Bookable tab for Schools"}
    contents={SCHOOL_PAGE_SECOND_CONTENT_DES_CONFIGS}
    underScoreColor={globalStyles.tertiary_70}
    desBoxBgColor={globalStyles.tertiary_95}
  />
);
export const SchoolPageSecondContentNSW = ({
  loadedAnimation,
}: IContentWithAnimation) => (
  <SchoolPageInfoDisplayBoxNSW
    loadedAnimation={loadedAnimation}
    title={"Why choose Spark?"}
    description={<>We employ our Teachers as casual employees, which means we handle all admin and payroll needs so you don't have to!<br /><br />Our user-friendly mobile app allows you to source and manage your casual relief teacher bookings at any time.</>}
    leftTopBgImg={sp_sc_bg_yellow}
    leftTopBgImgAlt={"sp_sc_bg_yellow"}
    leftBottomBgImg={sp_sc_bg_pink}
    leftBottomBgImgAlt={"sp_sc_bg_pink"}
    deviceImg={bookable}
    deviceImgAlt={"Spark Relief Teachers Bookable tab for Schools"}
    contents={SCHOOL_PAGE_SECOND_CONTENT_DES_CONFIGS}
    underScoreColor={globalStyles.tertiary_70}
    desBoxBgColor={globalStyles.tertiary_95}
  />
);

const SCHOOL_PAGE_THIRD_CONTENT_DES_CONFIGS = [
  {
    title: "Less Travel Time",
    des: "Teachers that are closer to your school will spend less time travelling and will arrive with shorter notice.",
  },
  {
    title: "Equal Access",
    des: "No matter how small or large your school is, you have equal access to requesting and booking nearby teachers.",
  },
];

export const SchoolPageThirdContent = ({
  loadedAnimation,
}: IContentWithAnimation) => (
  <SchoolPageInfoDisplayBox
    loadedAnimation={loadedAnimation}
    title={"Location-based Platform"}
    description={`Our priority is to ensure that teachers and schools are connected as efficiently as possible. This means that when you send out a request, teachers that are physically closer to your school will be prioritised.`}
    leftTopBgImg={sc_tc_pink_bg}
    leftTopBgImgAlt={"sc_tc_pink_bg"}
    leftBottomBgImg={sc_tc_blue_bg}
    leftBottomBgImgAlt={"sc_tc_blue_bg"}
    deviceImg={sc_tc_device}
    deviceImgAlt={"Finding nearby Teachers for CRT bookings - Spark Relief Teachers"}
    contents={SCHOOL_PAGE_THIRD_CONTENT_DES_CONFIGS}
    rowDirectionReversed={true}
    underScoreColor={globalStyles.primary_70}
    desBoxBgColor={""}
  />
);

const SCHOOL_PAGE_FORTH_CONTENT_DES_CONFIGS = [
  {
    title: "No Contracts",
    des: "There are no lock-in contracts, upfront costs, or exit fees for schools using Spark",
  },
  {
    title: "One Invoice",
    des: "To keep things simple, schools receive one invoice per week for all the completed placements from the week prior",
  },
  {
    title: "Less Admin",
    des: "All our teachers are employed by Spark, meaning we handle the payroll, insurance, compliance checks, and all administrative work for you!"
  }
];

export const SchoolPageForthContent = ({
  loadedAnimation,
}: IContentWithAnimation) => (
  <SchoolPageInfoDisplayBox
    loadedAnimation={loadedAnimation}
    title={"Pay As You Go"}
    description={`There are no registration or usage fees associated with Spark - you only pay for the teachers you book. We support our schools by handling payroll, saving you time and effort.`}
    leftTopBgImg={sp_forthC_blue_bg}
    leftTopBgImgAlt={"sp_forthC_blue_bg"}
    leftBottomBgImg={sp_forthC_yellow_bg}
    leftBottomBgImgAlt={"sp_forthC_yellow_bg"}
    deviceImg={sp_forthC_device}
    deviceImgAlt={"CRT bookings confirmed for Schools - Spark Relief Teachers"}
    contents={SCHOOL_PAGE_FORTH_CONTENT_DES_CONFIGS}
    underScoreColor={globalStyles.secondary_80}
    desBoxBgColor={globalStyles.secondary_95}
  />
);

const TP_FIFCONTENT_SLIDES_CONFIG = [
  {
    imageUrl: requestTeachers,
    imgAlt: "Spark Relief Teachers mobile application for schools to request nearby casual relief teachers",
    title: "1. Send Out Requests",
    des: "Schools can send out requests for as many days as they like without incurring any costs. By sending out requests, you are simply asking nearby available teachers whether they are willing to work at your school on that date.",
    buttonBgImg: tp_fif_banner_blue,
  },
  {
    imageUrl: bookableTeachers,
    buttonBgImg: tp_fif_banner_pink,
    imgAlt: "Schools can view bookable teachers to work at their school for upcoming dates",
    title: "2. Wait for Teacher Responses",
    des: "You will be notified when nearby teachers respond to your request. Remember, teachers do not use their phones during the day whilst in class so we recommend sending out requests early in advance.",
  },
  {
    imageUrl: teacherProfile,
    buttonBgImg: tp_fif_banner_yellow,
    imgAlt: "Schools are able to view teacher profiles on the Spark Relief Teachers mobile application when they are available to work",
    title: "3. View Profiles",
    des: "The teachers who confirm that they are happy to work at your school on the date that you requested will appear in your Bookable tab. From here you can view their profile and their favourite subjects.",
  },
  {
    imageUrl: confirmBooking,
    imgAlt: "Confirm bookable teachers when they are available to work on the Spark Relief Teachers mobile application",
    title: "4. Confirm Booking",
    des: "Once you have decided which teacher(s) you would like, you are able to confirm the booking. At this point in time you can leave notes for the teacher about who they are replacing and what they need to do.",
    buttonBgImg: tp_fif_banner_green,
  },
  {
    imageUrl: schoolInvoices,
    imgAlt: "Schools will receives invoices from Spark for booking completed the week prior",
    title: "5. One Weekly Invoice",
    des: "Your school will receive one invoice from Spark per week, for the bookings completed the week prior. Our teachers are our casual employees, which means we take care of all payroll so you don't have to.",
    buttonBgImg: tp_fif_banner_grey,
  },

];

export const SchoolPageFifthContent = ({
  loadedAnimation,
}: IContentWithAnimation) => (
  <TeacherPageFifthContent
    loadedAnimation={loadedAnimation}
    config={TP_FIFCONTENT_SLIDES_CONFIG}
  />
);

export const SchoolSixthContent = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <>
      <Stack className='flex_row_center'>
        <Stack
          className={styles.SchoolSixthContent_container}
          direction={screenType === "MOBILE" ? "column" : "row"}
          justifyContent={"center"}
          alignItems='center'
        >
          <Stack
            className={styles.sixC_text_container}
            justifyContent='center'
            alignItems='center'
          >
            <div
              style={{
                width: "100%",
                ...fadeIn(loadedAnimation),
                ...scaleUP(loadedAnimation),
                ...transitionCubicBezier,
              }}
              className={"heading1"}
            >
              Cost Breakdown
            </div>
            <div
              className={"paragraph2"}
              style={{
                ...fadeIn(loadedAnimation),
                ...transitionCubicBezier,
                transitionDelay: "0.1s",
              }}
            >
              <>
                Spark is committed to being transparent with both our Schools and
                CRTs about how much we charge and where the money is allocated.
                <br />
                <br />
                We align our teachers' pay with the Victorian State Government's{" "}
                <a
                  href='https://content.sdp.education.vic.gov.au/media/salary-casual-rates-of-pay-pdf-1715'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: "#C465A8", textDecoration: 'none' }}
                >
                  Maximum Daily Rate
                </a>
                . Our teachers are paid $421.58 plus superannuation and schools are
                charged $550.00 plus GST per booking.
                <br />
                <br />
                Check out our graph to understand how the team at Spark allocates
                the money charged to schools for a booking.
              </>
            </div>
            {/* style={{cursor: 'pointer', color: '#2DC5F4'}} onClick={() => window.open(`/${TabNames.HELP_DESK}`, '_self')} */}
          </Stack>
          <img
            src={school_charge_chart}
            alt='Victorian school cost breakdown chart'
            className={styles.sixC_text_img}
            style={{
              ...slideBasedOnMarginRight(loadedAnimation, "0px", "-100px"),
            }}
          />
        </Stack>
      </Stack>
    </>
  );
};

export const SchoolSixthContentNSW = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);
  const [band, setBand] = useState<1 | 2 | 3>(1);

  const [hoverBand, setHoverBand] = useState<1 | 2 | 3>();

  const handleMouseEnter = (band: 1 | 2 | 3) => {
    setHoverBand(band);
  }
  const handleMouseLeave = () => {
    setHoverBand(undefined);
  }

  const renderImage = useMemo(() => {
    return hoverBand ? hoverBand : band;
  }, [band, hoverBand]);

  const div1 = useRef<HTMLDivElement | null>(null);
  const div2 = useRef<SVGSVGElement | null>(null);
  const [distance, setDistance] = useState<number>();

  const calculateDistance = () => {
    if (div1.current && div2.current) {
      // get the bounding rectangles
      var div1rect = div1.current.getBoundingClientRect();
      var paddingTop = window.getComputedStyle(div1.current, null).getPropertyValue('padding-top').slice(0, -2);
      var div2rect = div2.current.getBoundingClientRect();

      // console.log('div1', div1rect);
      // console.log('div2', div2rect);
      // console.log('padding', paddingTop);


      // get div1's center point
      var div1y = div1rect.top;

      // get div2's center point
      var div2y = div2rect.top;
      setDistance(div2y - div1y - (parseInt(paddingTop)));
    }
  }

  useEffect(() => {
    calculateDistance();
    window.addEventListener('load', calculateDistance);
    window.addEventListener('DOMContentLoaded', calculateDistance);
    window.addEventListener('resize', calculateDistance);
    return () => {
      window.removeEventListener('load', calculateDistance);
      window.removeEventListener('DOMContentLoaded', calculateDistance);
      window.removeEventListener('resize', calculateDistance);
    }
  }, []);

  return (
    <>
      <Stack className='flex_row_center'>
        <Stack
          className={styles.SchoolSixthContent_container}
          direction={"column"}
          justifyContent={"center"}
          alignItems='center'
          gap={pxToRem(80)}
        >
          <Stack alignItems={'center'} gap={pxToRem(40)} width='100%'>
            <div
              style={{
                width: "100%",
                ...fadeIn(loadedAnimation),
                ...scaleUP(loadedAnimation),
                ...transitionCubicBezier,
                textAlign: 'center'
              }}
              className={"heading1"}
            >
              Cost Breakdown
            </div>
            <Stack direction='row' className={styles.costBreakdownContainer}>
              <Stack ref={div1}>
                <svg ref={div2} width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="40.5" cy="40" r="40" fill="#0081A3" fill-opacity="0.8" /> <path d="M40.0833 20L37.3719 30.8458C36.8428 32.9622 36.5782 34.0204 36.0273 34.8814C35.5399 35.6431 34.8931 36.2899 34.1314 36.7773C33.2704 37.3282 32.2122 37.5928 30.0958 38.1219L19.25 40.8333L30.0958 43.5448C32.2122 44.0739 33.2704 44.3384 34.1314 44.8894C34.8931 45.3768 35.5399 46.0236 36.0273 46.7852C36.5782 47.6463 36.8428 48.7045 37.3719 50.8209L40.0833 61.6667L42.7948 50.8209C43.3239 48.7045 43.5884 47.6463 44.1394 46.7852C44.6268 46.0236 45.2736 45.3768 46.0352 44.8894C46.8963 44.3384 47.9545 44.0739 50.0709 43.5448L60.9167 40.8333L50.0709 38.1219C47.9545 37.5928 46.8963 37.3282 46.0352 36.7773C45.2736 36.2899 44.6268 35.6431 44.1394 34.8814C43.5884 34.0204 43.3239 32.9622 42.7948 30.8458L40.0833 20Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /> </svg>
                <p className="paragraph2">Spark is committed to being transparent with both our Schools and Teachers about how much we charge and where the money is allocated.</p>
              </Stack>
              <Stack>
                <svg style={{ marginTop: `${distance}px` }} width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="40.5" cy="40" r="40" fill="#0081A3" fill-opacity="0.8" /> <path d="M40.56 55.65C38.2667 55.65 36.24 55.1967 34.48 54.29C32.7467 53.3833 31.2533 52.0233 30 50.21L32.96 46.81C34.2667 48.6767 35.52 49.97 36.72 50.69C37.92 51.41 39.3467 51.77 41 51.77C42.0133 51.77 42.9333 51.61 43.76 51.29C44.5867 50.97 45.24 50.53 45.72 49.97C46.2 49.41 46.44 48.77 46.44 48.05C46.44 47.57 46.36 47.1167 46.2 46.69C46.04 46.2633 45.7867 45.8767 45.44 45.53C45.12 45.1833 44.6933 44.8633 44.16 44.57C43.6533 44.2767 43.0533 44.0233 42.36 43.81C41.6667 43.57 40.8667 43.37 39.96 43.21C38.04 42.8367 36.44 42.2767 35.16 41.53C33.9067 40.7833 32.96 39.8367 32.32 38.69C31.7067 37.5433 31.4 36.21 31.4 34.69C31.4 33.57 31.64 32.53 32.12 31.57C32.6267 30.61 33.3067 29.7833 34.16 29.09C35.04 28.37 36.0667 27.8233 37.24 27.45C38.4133 27.05 39.68 26.85 41.04 26.85C43.2 26.85 45.08 27.2767 46.68 28.13C48.3067 28.9567 49.5867 30.17 50.52 31.77L47.48 34.77C46.68 33.4633 45.72 32.4633 44.6 31.77C43.5067 31.0767 42.28 30.73 40.92 30.73C39.88 30.73 38.9733 30.89 38.2 31.21C37.4267 31.53 36.8133 31.9833 36.36 32.57C35.9333 33.13 35.72 33.7967 35.72 34.57C35.72 35.13 35.8267 35.65 36.04 36.13C36.2533 36.5833 36.5733 36.9967 37 37.37C37.4533 37.7167 38.0533 38.0367 38.8 38.33C39.5467 38.5967 40.44 38.8367 41.48 39.05C42.9467 39.37 44.2533 39.7833 45.4 40.29C46.5467 40.77 47.52 41.3433 48.32 42.01C49.12 42.6767 49.72 43.4233 50.12 44.25C50.5467 45.0767 50.76 45.97 50.76 46.93C50.76 48.7167 50.3467 50.2633 49.52 51.57C48.6933 52.8767 47.52 53.89 46 54.61C44.48 55.3033 42.6667 55.65 40.56 55.65ZM38.16 58.89V40.73L42.04 42.05V58.89H38.16ZM43.64 42.05L39.76 40.73V23.97H43.64V42.05Z" fill="white" /> </svg>
                <p className="paragraph2">We support our Teachers by paying above the daily rate set by the New South Wales state government.</p>
              </Stack>
              <Stack>
                <svg style={{ marginTop: `${distance}px` }} width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="40.5" cy="40" r="40" fill="#0081A3" fill-opacity="0.8" /> <path d="M21.75 33.75H59.25M34.25 33.75L34.25 58.75M31.75 21.25H49.25C52.7503 21.25 54.5005 21.25 55.8374 21.9312C57.0135 22.5304 57.9696 23.4865 58.5688 24.6626C59.25 25.9995 59.25 27.7497 59.25 31.25V48.75C59.25 52.2503 59.25 54.0005 58.5688 55.3374C57.9696 56.5135 57.0135 57.4696 55.8374 58.0688C54.5005 58.75 52.7503 58.75 49.25 58.75H31.75C28.2497 58.75 26.4995 58.75 25.1626 58.0688C23.9865 57.4696 23.0304 56.5135 22.4312 55.3374C21.75 54.0005 21.75 52.2503 21.75 48.75V31.25C21.75 27.7497 21.75 25.9995 22.4312 24.6626C23.0304 23.4865 23.9865 22.5304 25.1626 21.9312C26.4995 21.25 28.2497 21.25 31.75 21.25Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /> </svg>
                <p className="paragraph2">Our rates vary depending on the level of experience of the booked teacher. These rates can be found in the table below.</p>
              </Stack>
            </Stack>
          </Stack>


          <Stack direction={screenType === "MOBILE" ? 'column' : 'row'} width='100%' justifyContent={screenType === "MOBILE" ? 'space-around' : 'space-between'} gap={pxToRem(40)}>
            <Stack className={styles.payRateTable}>
              <Stack direction={'row'}>
                <Stack>
                  <div>
                    <h2 className="paragraph1">Band</h2>
                  </div>
                  <div
                    className={`${styles.band} ${band === 1 ? styles['band--focused'] : hoverBand === 1 ? styles['band--hover'] : null}`}
                    onMouseEnter={() => handleMouseEnter(1)}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => setBand(1)}
                  >
                    <h2 className="paragraph1">1</h2>
                  </div>
                  <div
                    className={`${styles.band} ${band === 2 ? styles['band--focused'] : hoverBand === 2 ? styles['band--hover'] : null}`}
                    onMouseEnter={() => handleMouseEnter(2)}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => setBand(2)}
                  >
                    <h2 className="paragraph1">2</h2>
                  </div>
                  <div
                    className={`${styles.band} ${band === 3 ? styles['band--focused'] : hoverBand === 3 ? styles['band--hover'] : null}`}
                    onMouseEnter={() => handleMouseEnter(3)}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => setBand(3)}
                  >
                    <h2 className="paragraph1">3</h2>
                  </div>
                </Stack>
                <Stack>
                  <div>
                    <h2 className="paragraph1">Fee</h2>
                  </div>
                  <div
                    className={`${styles.band} ${band === 1 ? styles['band--focused--fee'] : hoverBand === 1 ? styles['band--hover'] : null}`}
                    onMouseEnter={() => handleMouseEnter(1)}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => setBand(1)}
                  >
                    <h2 className="paragraph1">${BAND1_COST}</h2>
                    <div></div>
                  </div>
                  <div
                    className={`${styles.band} ${band === 2 ? styles['band--focused--fee'] : hoverBand === 2 ? styles['band--hover'] : null}`}
                    onMouseEnter={() => handleMouseEnter(2)}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => setBand(2)}
                  >
                    <h2 className="paragraph1">${BAND2_COST}</h2>
                    <div></div>
                  </div>
                  <div
                    className={`${styles.band} ${band === 3 ? styles['band--focused--fee'] : hoverBand === 3 ? styles['band--hover'] : null}`}
                    onMouseEnter={() => handleMouseEnter(3)}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => setBand(3)}
                  >
                    <h2 className="paragraph1">${BAND3_COST}</h2>
                    <div></div>
                  </div>
                </Stack>
              </Stack>
            </Stack>
            <Stack className={styles.payChart}>
              <h1 className="heading1">Placement Fees - Band {renderImage}</h1>
              <div style={{ position: 'relative', marginInline: 'auto' }} className={styles.sixC_text_img_container}>
                <div style={{ position: 'absolute', left: 0, right: 0, marginInline: 'auto', width: 'fit-content' }}>
                  <Fade in={renderImage === 1}>
                      <img
                        src={nswBand1}
                        alt='NSW school cost breakdown chart for Band 1'
                        className={styles.sixC_text_img}
                      />
                  </Fade>
                </div>
                <div style={{ position: 'absolute', left: 0, right: 0, marginInline: 'auto', width: 'fit-content' }}>
                  <Fade in={renderImage === 2}>
                    <img
                      src={nswBand2}
                      alt='NSW school cost breakdown chart for Band 2'
                      className={styles.sixC_text_img}
                    />
                  </Fade>
                </div>
                <div style={{ position: 'absolute', left: 0, right: 0, marginInline: 'auto', width: 'fit-content' }}>
                  <Fade in={renderImage === 3}>
                    <img
                      src={nswBand3}
                      alt='NSW school cost breakdown chart for Band 3'
                      className={styles.sixC_text_img}
                    />
                  </Fade>
                </div>
              </div>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

const SCHOOL_FAQ_CONFIGS = [
  {
    question: "How long does it take to register my school?",
    answer: (
      <div className='TPFifthContent__Accordion__answer__para'>
        The registration process for schools takes less than 5 minutes.
        <br />
        <br />
        All you need to do is register an account as a School user and set up a profile for your school by entering basic details such as bell times.
        <br />
        <br />
        Our team will then contact your school to verify that you have the authority to book casual relief teachers on behalf of the school and that the details that you have entered are correct.
        <br />
        <br />
        Your account will typically be approved within one business day of registering, after which you will immediately be able to request and confirm teachers.
      </div>
    ),
  },
  {
    question: "Can I still use other CRT agencies if I use Spark?",
    answer: (
      <div className='TPFifthContent__Accordion__answer__para'>
        Absolutely! We understand that some schools need to use multiple services to meet their staffing needs, which is why there are no contracts or fees associated with using Spark.
      </div>
    ),
  },
  {
    question: "What differentiates Spark from other CRT Agencies?",
    answer: (
      <div className='TPFifthContent__Accordion__answer__para'>
        Spark is a CRT booking platform with no intermediaries. This means that all activity occurs directly between our schools and teachers and there are no consultants allocating teachers to schools at their own discretion.
        <br />
        <br />
        Schools and teachers do not need to call anyone to confirm a booking or cancel a booking. Simply open the Spark mobile app and you will have complete control over your profile and your bookings.
      </div>
    ),
  },
  {
    question: "Can I have more than one user on my school account?",
    answer: (
      <div className='TPFifthContent__Accordion__answer__para'>
        Yes, school accounts can have more than one user. In fact, they can have
        as many users as they require at no additional cost.
        <br />
        <br />
        Each additional user simply needs to register their own profile via the Spark mobile
        app before searching for the school and requesting to join.
        <br />
        <br />
        The school account's Admin has the authority to approve or reject
        additional users who have requested to join.
      </div>
    ),
  },
  {
    question: "Who is the account Admin?",
    answer: (
      <div className='TPFifthContent__Accordion__answer__para'>
        By default, the account Admin is the first user who registered the school
        and was originally authenticated by the Spark Relief Teachers Onboarding
        team.
        <br />
        <br />
        The original account Admin has the authority to make any other school
        user an Admin of the account.
        <br />
        <br />
        The account Admin also has the authority to approve or reject any
        additional users who request access to the school account.
        <br />
        <br />
        If you are experiencing issues accessing your school's account, please
        contact us via the{" "}
        <span
          style={{ cursor: "pointer", color: "#C465A8" }}
          onClick={() => window.open(`/${TabNames.HELP_DESK}`, "_self")}
        >
          Help Desk
        </span>
        .
      </div>
    ),
  },
];

export const SchoolSeventhContent = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const navigate = useNavigate();
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <Stack className='flex_row_center'>
      <Stack
        className={styles.SchoolSeventhContent_container}
        direction={screenType === "PC" ? "row" : "column"}
        justifyContent='center'
        alignItems={screenType === "PC" ? "unset" : "center"}
      >
        <Stack className={styles.SchoolSeventhContent_textStack}>
          <Box
            className={
              screenType === "MOBILE"
                ? "title_large semi_bold_weight"
                : "headLine_large bold_weight"
            }
          >
            Frequently Asked Questions
          </Box>
          <img
            src={sp_sev_img}
            alt='Frequently asked questions for Spark Relief Teachers'
            className={styles.SchoolSeventhContent_img}
          />
        </Stack>
        <Stack
          className={styles.SchoolSeventhContent_accordionWrapper}
          sx={{ ...slideBasedOnMarginTop(loadedAnimation, "0px", "100px") }}
        >
          <StyledAccordion configs={SCHOOL_FAQ_CONFIGS} />
          <div
            className={`${styles.backButton} title_medium`}
            onClick={() => navigate(`/${TabNames.SCHOOL_FAQ}`)}
            style={{ color: "#C465A8" }}
          >
            {"More School FAQ's >"}
          </div>
        </Stack>
      </Stack>
    </Stack>
  );
};


export const VicContent = ({ loadedAnimation }: IContentWithAnimation) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <Stack className='flex_row_center'>
      <Stack
        className={styles.vic_container}
        direction={screenType === "MOBILE" ? "column-reverse" : "row"}
        justifyContent={"center"}
        alignItems='center'
      >
        <Stack className={styles.vicEndorsed}>
          <Stack>
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="60" cy="60" r="54" fill="#02A674" stroke="#97D6C3" strokeWidth="12" /> <path d="M85 41.25L50.625 75.625L35 60" stroke="white" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" /> </svg>
            <Stack flex={1}>
              <h1>Endorsed by the Department of Education</h1>
              <Divider flexItem />
            </Stack>
          </Stack>
          <p>Spark Relief Teachers is a member of the Victorian Department of Education's CRT Panel. This means we are a Department approved supplier of casual relief teachers and all Victorian schools are encouraged to use Spark for their CRT booking needs.<br /><br />Our endorsement by the Department of Education highlights our commitment to building relationships with schools and teachers across Victoria. </p>
        </Stack>
      </Stack>
    </Stack>
  )
}


export const NswContent = ({ loadedAnimation }: IContentWithAnimation) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <Stack className='flex_row_center'>
      <Stack
        className={styles.nsw_container}
        direction={screenType === "MOBILE" ? "column-reverse" : "row"}
        justifyContent={"center"}
        alignItems='center'
      >
        <Stack className={styles.nswContent}>
          <Stack>
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="60" cy="60" r="54" fill="#A54D9D" stroke="#F1D8EA" strokeWidth="12" /> <path d="M85 41.25L50.625 75.625L35 60" stroke="white" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" /> </svg>
            <Stack flex={1}>
              <h1>We take care of teacher payroll</h1>
              <Divider flexItem />
            </Stack>
          </Stack>
          <p>Your school will receive one invoice from Spark per week, for the bookings completed the week prior. Our teachers are our casual employees, which means we take care of all payroll so you don't have to.</p>
        </Stack>
      </Stack>
    </Stack>
  )
}